import { useDispatch, useSelector } from "../../../hooks";
import { AgeRange, Gender } from "../../../redux/profile";
import maleIcon from "./icons/male.png";
import femaleIcon from "./icons/female.png";
import { useEffect, useState } from "react";
import styles from "./ProfilePage.module.scss";
import { ContentWrapper } from "../../../components/ContentWrapper/ContentWrapper";
import { PageTitleBlock } from "../../../components/PageTitleBlock/PageTitleBlock";
import { Button } from "../../../components/Buttons/Button/Button";
import { setProfile } from "../../../redux/profile/set-profile.handler";
import { QuizContext } from "../QuizRoutes";
import { Loader } from "../../../components/Loader/Loader";
import { ErrorSnackbar } from "../../../components/ErrorSnackbar/ErrorSnackbar";
import { AppContext } from "../../../components/Menu/MenuButton";
import { useNavigate } from "react-router-dom";

export const getAgeRangeDescription = (age: AgeRange) => {
    switch (age) {
        case AgeRange.UpTo18: return "До 18 лет";
        case AgeRange.From18To30: return "От 18 до 29 лет";
        case AgeRange.From30To50: return "От 30 до 50 лет";
        case AgeRange.From50: return "Более 50 лет";
    }
}

export const ProfilePage = () => {
    const [selectedGender, setSelectedGender] = useState<Gender>(Gender.Unknown);
    const [selectedAgeRange, setSelectedAgeRange] = useState<AgeRange>(AgeRange.Unknown);

    const { error, loading, gender, ageRange } = useSelector(store => store.user.profile);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (gender !== Gender.Unknown)
            setSelectedGender(gender);

        if (ageRange !== AgeRange.Unknown)
            setSelectedAgeRange(ageRange);
    }, [gender, ageRange]);

    const isFilled = () => selectedGender !== Gender.Unknown && selectedAgeRange !== AgeRange.Unknown;

    const onSaveHandler = async () => {
        const resultAction = await dispatch(setProfile({ gender: selectedGender, ageRange: selectedAgeRange }));
        if (setProfile.fulfilled.match(resultAction))
            navigate(`/${AppContext.Quiz}/${QuizContext.Themes}`);
    }

    return (
        <>
            <ContentWrapper>
                <div className={styles.cardWrapper}>
                    <PageTitleBlock
                        pageDescription={`Укажите ваш пол и возраст, чтобы мы могли подобрать подходящие вопросы`}
                        pageTitle={`Участвовать в викторине`}
                    />
                </div>

                <div className={styles.container}>
                    <div className={styles.genderSelection}>
                        <div
                            className={`${styles.gender} ${styles.male} ${selectedGender === Gender.Male ? styles.active : ""}`}
                            onClick={() => setSelectedGender(Gender.Male)}
                        >
                            <div className={styles.genderInfo}>
                                <img src={ maleIcon } alt="Мужской" />
                                <span>Мужской</span>
                            </div>

                            <div className={styles.radioButton}>
                                { selectedGender === Gender.Male && <div className={styles.innerCircle} /> }
                            </div>
                        </div>

                        <div
                            className={`${styles.gender} ${styles.female} ${selectedGender === Gender.Female ? styles.active : ""}`}
                            onClick={() => setSelectedGender(Gender.Female)}
                        >
                            <div className={styles.genderInfo}>
                                <img src={ femaleIcon } alt="Женский" />
                                <span>Женский</span>
                            </div>

                            <div className={styles.radioButton}>
                                { selectedGender === Gender.Female && <div className={styles.innerCircle} /> }
                            </div>
                        </div>
                    </div>

                    <div className={styles.ageSelection}>
                        { [AgeRange.UpTo18, AgeRange.From18To30, AgeRange.From30To50, AgeRange.From50].map(
                            (age: AgeRange, index) => (
                                <button
                                    key={index}
                                    className={`${styles.ageButton} ${selectedAgeRange === age ? styles.active : ""}`}
                                    onClick={() => setSelectedAgeRange(age)}
                                >
                                { getAgeRangeDescription(age) }
                                </button>
                            )
                        )}
                    </div>

                    { isFilled() && <Button caption='Сохранить' handler={ onSaveHandler } /> }
                </div>
            </ContentWrapper>

            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
}



      
